import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })

export class TitleUpdateService {

    constructor(
        private title: Title,
        private router: Router
    ) { }

    setTitleFromRoute(): void {
        const url = this.router.url;
        const cleanUrl = url.split('?')[0].split('#')[0];

        const parts = cleanUrl.replace(/^\/|\/$/g, '').split('/');
        let rawTitle: string = parts[parts.length - 1] || 'Home';

        rawTitle = rawTitle.replace(/&/g, ' and ');
        rawTitle = rawTitle.replace(/_/g, ' ');
        rawTitle = rawTitle.replace(/\s+/g, ' ').trim();

        if (rawTitle.includes("-home")) {
            rawTitle = rawTitle.replace('-home', '').toUpperCase();
            this.title.setTitle(`${rawTitle}`);
            return;
        }

        this.title.setTitle(`${environment.TITLE_PREFIX}: ${rawTitle}`);
    }

    getUrlFromTitle(title: string): string {
        let segment = title;
        segment = segment.replace(/^VMANICO:\s*/i, '');
        segment = segment.replace(/\band\b/g, '&');
        segment = segment.replace(/\s+/g, '_');

        return segment;
    }

}